export const apiConstants = {
  url: "/api/rule",
  doortypes: "/api/doortype"
};
